// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__XSvmp","header":"ReportDetails_header__1WE16","title":"ReportDetails_title__1o_j3","left":"ReportDetails_left__2Mgdt"};